require('./bootstrap');

window.Vue = require('vue');

// Imports
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err && err.name !== 'NavigationDuplicated') {
            return Promise.reject(err)
        }
    })
}

//import Bshvue from 'bshvue'
import Bshvue from './bshvue/src/index'
Vue.use(Bshvue)

// Components
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Prototypes
Vue.prototype.$url = APP_URL;

// routes 
import routes from './routes/app'

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
})

// Instance vue
const app = new Vue({
    el: '#app',
    router
});